import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Rating from "@mui/material/Rating";

const CustomRatingStar = ({star}) => {
	const getRatingColor = (star) => {
		switch (Math.floor(star)) {
			case 1:
				return "#fd7e14";
			case 2:
				return "#ffc107";

			case 3:
				return "#ffc107";
			case 4:
				return "#28a745";
			case 5:
				return "#28a745";
			default:
				return "#6c757d";
		}
	};
	return (
		<Box sx={{display: "flex", alignItems: "center", gap: 0.5}}>
			<Typography variant="body2" color="">
				{Number(star)?.toFixed(1) || ""}
			</Typography>
			{star && <Rating readOnly precision={0.5} size="small" defaultValue={(star ? Number(star) : 5) || 5} sx={{fontSize: 15, color: getRatingColor(star)}} />}
		</Box>
	);
};

export default CustomRatingStar;
